/* __next_internal_client_entry_do_not_use__ Shakeable,ShakeAnimation auto */ import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled, { css, keyframes } from "styled-components";
export var Shakeable = function(props) {
    var containerRef = React.useRef(null);
    React.useEffect(function() {
        props.shaker.current = {
            shake: function() {
                if (!containerRef.current) {
                    return;
                }
                containerRef.current.classList.add("shake");
                setTimeout(function() {
                    var _containerRef_current;
                    (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.classList.remove("shake");
                }, 2000);
            }
        };
    }, [
        props.shaker
    ]);
    return /*#__PURE__*/ _jsx(ShakeableContainer, {
        ref: containerRef,
        className: props.className,
        children: props.children
    });
};
var shake = function() {
    var base = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "0px";
    return keyframes([
        "10%,90%{transform:translateX(calc(",
        " + -1px));}20%,80%{transform:translateX(calc(",
        " + 2px));}30%,50%,70%{transform:translateX(calc(",
        " + -4px));}40%,60%{transform:translateX(calc(",
        " + 4px));}"
    ], base, base, base, base);
};
export var ShakeAnimation = function() {
    var base = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "0px";
    return css([
        "transform:translateX(",
        ");animation:",
        " 0.82s cubic-bezier(0.36,0.07,0.19,0.97) both;"
    ], base, shake(base));
};
var ShakeableContainer = styled.div.withConfig({
    componentId: "sc-d3f499f3-0"
})([
    "width:100%;&.shake{",
    " backface-visibility:hidden;perspective:1000px;}"
], ShakeAnimation());
